import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CasesQueryParams,
  PaginatedCasesResult,
  VersionHistoryEntry,
  TraceabilityMetrics,
  TraceabilityMetricsFilterParams
} from '@model/traceability/traceability.model';
import {
  ITraceabilityQueryPort,
  TRACEABILITY_QUERY_PORT
} from '@domain/service/traceability/traceability-query.port';
import {
  ITraceabilityCommandPort,
  TRACEABILITY_COMMAND_PORT,
  UpdatePrioritizationRequest
} from '@domain/service/traceability/traceability-command.port';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityPresenter {
  private readonly traceabilityPort = inject<ITraceabilityQueryPort>(
    TRACEABILITY_QUERY_PORT
  );
  private readonly commandPort = inject<ITraceabilityCommandPort>(
    TRACEABILITY_COMMAND_PORT
  );

  getSamples(params?: CasesQueryParams): Observable<PaginatedCasesResult> {
    return this.traceabilityPort.getSamples(params);
  }

  /**
   * Gets the version history for a case.
   * @param identifier Case number or LG number
   */
  getSampleHistory(identifier: string): Observable<VersionHistoryEntry[]> {
    return this.traceabilityPort.getVersionHistory(identifier);
  }


  getMetrics(
    params?: TraceabilityMetricsFilterParams
  ): Observable<TraceabilityMetrics> {
    return this.traceabilityPort.getMetrics(params);
  }


  getMetricsStream(
    params?: TraceabilityMetricsFilterParams,
    intervalMs?: number
  ): Observable<TraceabilityMetrics> {
    return this.traceabilityPort.getMetricsStream(params, intervalMs);
  }

  exportSamplesToCSV(params?: CasesQueryParams): Observable<Blob> {
    return this.traceabilityPort.exportSamplesToCSV(params);
  }

  updatePrioritization(
    lgCode: string,
    request: UpdatePrioritizationRequest
  ): Observable<void> {
    return this.commandPort.updatePrioritization(lgCode, request);
  }
}
